import { render, staticRenderFns } from "./business_add.vue?vue&type=template&id=650d88d6&scoped=true&"
import script from "./business_add.vue?vue&type=script&lang=js&"
export * from "./business_add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d88d6",
  null
  
)

export default component.exports